export const widescreensize: number = 1216; // widescreen size
export const desktopscreensize: number = 1024; //desktop size
export const tabletscreensize: number = 769; //tablet size
export const mobilescreensize: number = 480; //mobile size

export const jumbotronxsscreensize: number = 420;
